import { none, propEq, values } from 'ramda';
import { ACTION, AdvancedPlayerMessage, BUTTON_TYPE } from '@core/js/components/popups/AdvancedPlayerMessage';
import uuid from 'uuid-random';
import { addPopupAction, LAYER } from '@core/js/components/common/PopupManager';

export const actionShowAdvancedDialogInfo = ({ actionId, actionInfo, push }) => {
    let { buttons = [] } = actionInfo;

    const unsupportedButton = buttons
        .filter(btn => btn.action)
        .find(btn => !values(ACTION).includes(btn.action));

    if (unsupportedButton) {
        console.warn('Unsupported button action', unsupportedButton);
        return;
    }

    const isModal = none(propEq('buttonType', BUTTON_TYPE.CLOSE), buttons);
    buttons = buttons.map(({ buttonId = uuid(), ...rest }) => ({ ...rest, buttonId }));

    return addPopupAction({
        id: actionId,
        component: AdvancedPlayerMessage,
        layoutClassName: 'lobby-message', /* Solverde changes */
        layer: isModal ? LAYER.ADVANCED_PLAYER_MESSAGE_MODAL : LAYER.ADVANCED_PLAYER_MESSAGE,
        isModal,
        data: {
            ...push.data,
            action: {
                ...actionInfo,
                buttons
            }
        }
    });
};
